import { actionTypes as purchaseOrderActionTypes } from '../action-types/purchase-order';
import myTraderaItemActions from '../actions/my-tradera-items';

const initialState = {
    purchaseOrders: []
};

const updatePurchaseOrderPaidBySeller = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.map(purchaseOrder =>
            purchaseOrder.purchaseOrderId === action.payload.purchaseOrderId
                ? {
                      ...purchaseOrder,
                      state: {
                          ...purchaseOrder.state,
                          isPaid: action.payload.isPaid
                      }
                  }
                : purchaseOrder
        )
    };
};

const updatePurchaseOrderPaidByBuyer = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.map(purchaseOrder =>
            purchaseOrder.purchaseOrderId === action.payload.purchaseOrderId
                ? {
                      ...purchaseOrder,
                      state: {
                          ...purchaseOrder.state,
                          isMarkedAsPaidByBuyer:
                              action.payload.isMarkedAsPaidByBuyer
                      }
                  }
                : purchaseOrder
        )
    };
};

const updatePurchaseOrderShipped = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.map(purchaseOrder =>
            purchaseOrder.purchaseOrderId === action.payload.purchaseOrderId
                ? {
                      ...purchaseOrder,
                      state: {
                          ...purchaseOrder.state,
                          isShipped: action.payload.isShipped
                      }
                  }
                : purchaseOrder
        )
    };
};

const updatePurchaseOrderRequestCombinedShipping = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.map(purchaseOrder =>
            purchaseOrder.purchaseOrderId === action.payload.purchaseOrderId
                ? {
                      ...purchaseOrder,
                      combinedShippingInformation: {
                          ...purchaseOrder.combinedShippingInformation,
                          buyerRequestedCombinedShippingPriceDate: Date.now(),
                          hasBuyerRequestedCombinedShippingPrice:
                              action.payload
                                  .hasBuyerRequestedCombinedShippingPrice
                      }
                  }
                : purchaseOrder
        )
    };
};

const updatePurchaseOrderShippingPrice = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.map(purchaseOrder =>
            purchaseOrder.purchaseOrderId === action.purchaseOrderId
                ? {
                      ...purchaseOrder,
                      ...(purchaseOrder.combinedShippingInformation
                          ? {
                                combinedShippingInformation: {
                                    ...purchaseOrder.combinedShippingInformation,
                                    sellerSetCombinedShippingPriceDate: Date.now()
                                }
                            }
                          : null),
                      shippingAmount: action.newPrice,
                      totalAmount:
                          parseInt(action.newPrice) +
                          parseInt(purchaseOrder.totalItemAmount),
                      shipping: {
                          ...purchaseOrder.shipping,
                          shippingDiscount: {
                              shippingCost: action.newPrice,
                              shippingType: action.shippingProvider
                          }
                      }
                  }
                : purchaseOrder
        )
    };
};

const updatePurchaseOrderShipment = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.map(purchaseOrder =>
            purchaseOrder.purchaseOrderId === action.payload.purchaseOrderId
                ? {
                      ...purchaseOrder,
                      state: {
                          ...purchaseOrder.state,
                          hasUnpaidShipping: false
                      }
                  }
                : purchaseOrder
        )
    };
};

const updatePurchaseOrderShippedBooked = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.map(purchaseOrder =>
            purchaseOrder.purchaseOrderId === action.payload.purchaseOrderId
                ? {
                      ...purchaseOrder,
                      state: {
                          ...purchaseOrder.state,
                          isShippingBooked: action.payload.isBooked
                      }
                  }
                : purchaseOrder
        )
    };
};

const updatePurchaseOrders = (state, action) => {
    return {
        ...state,
        paging: {
            ...action.payload.paging
        },
        statistics: action.payload.statistics,
        purchaseOrders: action.payload.purchaseOrders.map(purchaseOrder => {
            const { rows, ...filteredPurchaseOrder } = purchaseOrder;
            return {
                ...filteredPurchaseOrder
            };
        })
    };
};

const checkHaveGivenFeedBackTo = (action, purchaseOrder) => {
    const itemsToGiveFeedBackTo = purchaseOrder.itemsToGiveFeedBackTo
        .map(itemToGiveFeedBackTo => {
            const haveGivenFeedBackTo = action.payload.submittables.filter(
                submittable => {
                    return submittable.transactionId === itemToGiveFeedBackTo;
                }
            ).length;
            if (haveGivenFeedBackTo) {
                return null;
            }
            return itemToGiveFeedBackTo;
        })
        .filter(Boolean);
    return itemsToGiveFeedBackTo;
};

const updatePurchaseOrderFeedback = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.map(purchaseOrder =>
            purchaseOrder.purchaseOrderId === action.payload.purchaseOrderId
                ? {
                      ...purchaseOrder,
                      itemsToGiveFeedBackTo: checkHaveGivenFeedBackTo(
                          action,
                          purchaseOrder
                      )
                  }
                : purchaseOrder
        )
    };
};

// Updating hidden always hides the order from the current list
const updatePurchaseOrderHidden = (state, action) => {
    return {
        ...state,
        purchaseOrders: state.purchaseOrders.filter(
            purchaseOrder =>
                purchaseOrder.purchaseOrderId !== action.payload.purchaseOrderId
        )
    };
};

export default (state = initialState, action) => {
    switch (action.type) {
        case myTraderaItemActions.actionTypes
            .PURCHASE_ORDERS_MARKED_AS_PAID_BY_SELLER:
            return updatePurchaseOrderPaidBySeller(state, {
                payload: {
                    purchaseOrderId: action.payload.ids[0],
                    isPaid: true
                }
            });
        case myTraderaItemActions.actionTypes
            .PURCHASE_ORDERS_UNMARKED_AS_PAID_BY_SELLER:
            return updatePurchaseOrderPaidBySeller(state, {
                payload: {
                    purchaseOrderId: action.payload.ids[0],
                    isPaid: false
                }
            });
        case myTraderaItemActions.actionTypes
            .PURCHASE_ORDERS_MARKED_AS_PAID_BY_BUYER:
            return updatePurchaseOrderPaidByBuyer(state, {
                payload: {
                    purchaseOrderId: action.payload.ids[0],
                    isMarkedAsPaidByBuyer: true
                }
            });
        case myTraderaItemActions.actionTypes
            .PURCHASE_ORDERS_UNMARKED_AS_PAID_BY_BUYER:
            return updatePurchaseOrderPaidByBuyer(state, {
                payload: {
                    purchaseOrderId: action.payload.ids[0],
                    isMarkedAsPaidByBuyer: false
                }
            });
        case purchaseOrderActionTypes.PURCHASE_ORDER_RESET:
            return initialState;
        case purchaseOrderActionTypes.PURCHASE_ORDERS_SHIPPING_BOOKED:
            return updatePurchaseOrderShippedBooked(state, action);
        case purchaseOrderActionTypes.PURCHASE_ORDER_REQUEST_COMBINED_SHIPPING:
            return updatePurchaseOrderRequestCombinedShipping(state, action);
        case purchaseOrderActionTypes.PURCHASE_ORDER_SHIPPED:
            return updatePurchaseOrderShipped(state, action);
        case purchaseOrderActionTypes.PURCHASE_ORDER_PAID_BY_BUYER:
            return updatePurchaseOrderPaidByBuyer(state, action);
        case purchaseOrderActionTypes.PURCHASE_ORDER_PAID_BY_SELLER:
            return updatePurchaseOrderPaidBySeller(state, action);
        case myTraderaItemActions.actionTypes.SET_NEW_SHIPPING_PRICE:
            return updatePurchaseOrderShippingPrice(state, action);
        case purchaseOrderActionTypes.PURCHASE_ORDER_LIST:
            return updatePurchaseOrders(state, action);
        case purchaseOrderActionTypes.PURCHASE_ORDER_DELETE_SHIPMENT:
            return updatePurchaseOrderShipment(state, action);
        case purchaseOrderActionTypes.PURCHASE_ORDERS_FEEDBACK_LEFT_BY_BUYER:
        case purchaseOrderActionTypes.PURCHASE_ORDERS_FEEDBACK_LEFT_BY_SELLER:
            return updatePurchaseOrderFeedback(state, action);
        case purchaseOrderActionTypes.PURCHASE_ORDER_HIDDEN:
            return updatePurchaseOrderHidden(state, action);
        default:
            return state;
    }
};
